{
    "roadmap": {
        "common": {
            "openAll": "Öppna alla",
            "closeAll": "Stäng alla",
            "openorCloseTitle": "Öppna/Stäng alla dragspel"
        },
        "nextGen": {
            "nextGenTitle": "NextGen IT",
            "nextGenDesc": "Vad är NextGen IT: Ta IT-automation till slutanvändaren och få problemet löst snabbare.",
            "acc1Title": "I produktion",
            "prodItem1": "KB Artikelintegration: 300+ KB artiklar som möjliggör IT-självlösning",
            "prodItem2": "Självläkande lösning: Mer än 18 fjärrskript är tillgängliga för att lösa problemet.",
            "prodItem3": "Incidenthantering: Säkerställer korrekt och snabbare lösning genom automatiserad incidentloggning.",
            "prodItem4": "Chatta med liveagent (mänsklig agent): MyHelp tillåter användare att chatta med en mänsklig agent från AI-assistenten",
            "acc2Title": "Under utveckling",
            "devItem1": "Schemalägg återuppringning (Feb - 2026): Schemalägg en IT-supportåteruppringning vid en tid som passar din tillgänglighet",
            "devItem2": "Intelligent routing (Feb - 2026): Dirigera biljetter till rätt lösningsteam för snabbare support",
            "acc3Title": "Backlog",
            "backItem1": "PKI felsökningsagent: MyHelp integration med PKI felsökningsagent för att hantera certifikatrelaterade problem",
            "backItem2": "Schemalägg besök på Walk‑in Center direkt genom MyHelp"
        },
        "corporate": {
            "title": "Företag",
            "desc": "Företaget ansvarar för att hantera företagsapplikationer, HR-plattformar, som stödjer arbetskraft och affärsfunktioner.",
            "acc1Title": "I produktion",
            "prodItem1": "BU-baserade appar: 90+ appar med BU-baserad personalisering",
            "prodItem2": "Anpassad appfästning: Användare kan anpassa sin MyHelp-dashboard genom att fästa anpassade appar",
            "prodItem3": "Arbetsplatsfrågor: 100+ arbetsplatsfrågor (kontor, parkering, byggnader)",
            "prodItem4": "Bokning av mötesrum med AI-assistent: Snabb, förenklad bokning av mötesrum med Gingco-integration",
            "prodItem5": "HR-frågor: MyHelp svarar på de 50 vanligaste HR-frågorna",
            "prodItem6": "Personsökning: Användare kan söka efter sina E.ON-kollegor genom MyHelp",
            "acc2Title": "Under utveckling",
            "devItem1": "Applikationsintroduktion baserat på affärsenhetsutveckling.",
            "devItem2": "Mötesrum AI-assistent",
            "acc3Title": "I backlog",
            "backItem1": "Lägg till appar från AI-assistenten och anpassade flikar: Lägg till appar direkt genom MyHelp-assistentens föreslagna alternativ"
        },
        "myGenius": {
            "title": "MyGenius",
            "desc": "Denna integration hjälper dig att hitta relevanta utbildningar och kurser.",
            "acc1Title": "I produktion",
            "prodItem1": "Sök utbildningar & kurser: Hitta relevanta utbildningar och kurser med MyHelp",
            "acc2Title": "Under utveckling",
            "acc3Title": "I backlog",
            "backItem1": "Personlig lärande: Personliga utbildningsrekommendationer baserat på affärsenhetsberättigande."
        },
        "myItOrder": {
            "title": "MyIT order",
            "desc": "Denna integration hjälper dig att hitta relevanta IT-beställningsartiklar och kataloger.",
            "acc1Title": "I produktion",
            "prodItem1": "Snabb IT-beställningskatalogsökning: Snabb sökning och beställning av din IT från MyHelp",
            "prodItem2": "Aktivering och återkallande av programvaruåtkomst: Aktivera eller återkalla programvaruåtkomst genom navigering från MyHelp.",
            "acc2Title": "Under utveckling",
            "devItem1": "Översikt över IT-tillgångskostnader: MyHelp kommer att visa en kostnadsöversikt över dina IT-tillgångar",
            "acc3Title": "I backlog",
            "backItem1": "Central godkännande av beställda artiklar"
        },
        "compass": {
            "title": "Kompass",
            "desc": "Denna integration hjälper dig att hitta gemenskap, nyhetsinformation och meddelanden som delas på intranätet.",
            "acc1Title": "I produktion",
            "prodItem1": "Släpps den 28 februari 2026",
            "acc2Title": "Under utveckling",
            "devItem1": "Kompasssökning (Feb – 2026): E.ON-användare kommer att kunna söka sin gemenskapsdata i MyHelp E.ON-sökning",
            "devItem2": "MyHelp-Kompass AI-assistent (pågående) (Feb – 2026): Möjliggör för E.ON-användare att få tillgång till gemenskapsdata genom MyHelp AI-assistenten",
            "acc3Title": "I backlog"
        },
        "chatProjectData": {
            "title": "Chatta med dina projektdata",
            "desc": "Denna integration tillåter dig att introducera dina projektdata från confluence, sharepoint etc.",
            "acc1Title": "I produktion",
            "prodItem1": "Confluence One Billing och DSODP-projekt är introducerade",
            "prodItem2": "SharePoint-sidor – DSODP-projektsidan är introducerad",
            "acc2Title": "Under utveckling",
            "devItem1": "Arbetet med att integrera Nautilus-projektdata pågår.",
            "acc3Title": "I backlog"
        },
        "personalization": {
            "title": "Personalisering",
            "acc1Title": "I produktion",
            "prodItem1": "Flerspråkig: stöder 4 språk (Engelska, Deutsch, Svenska, Română)",
            "prodItem2": "Flera teman: tillåter varje affärsenhet eller region att använda sin egen varumärkning, vilket förbättrar igenkänning och adoption.",
            "prodItem3": "5 ytterligare nya språk under beta-profil (Čeština, Italiano, Magyar, Nederlands och Polski)",
            "acc2Title": "Under utveckling",
            "devItem1": "Dataspecifik källa: (15 februari – 2026): ger mer riktade och kontextmedvetna svar genom att hämta information från användarens valda datakällor.",
            "acc3Title": "I backlog"
        },
        "technicalEnablement": {
            "title": "Teknisk möjliggörande",
            "acc1Title": "I produktion",
            "prodItem1": "Säkerhet & Observabilitet säkerställer företagsklassad dataskydd, efterlevnad och prestanda, och möjliggör säker, pålitlig och smidig drift",
            "prodItem2": "KPI & adoptionsdashboards (Power BI)<br /> Ger tydlig insikt i användning, värderealisering och affärspåverkan genom KPI-dashboards",
            "acc2Title": "Under utveckling",
            "devItem1": "Multiagent arbetsflöde den 15 mars 2026: Möjliggör mer avsiktsdrivna konversationer som inte bara förbättrar svarens relevans utan också utför från början till slut för användare.",
            "acc3Title": "I backlog",
            "backItem1": "MCP-ramverk (Backlog): <br /> Ger en grund för att orkestrera och samordna AI-agenter över E.ON, vilket möjliggör skalbara och samarbetsinriktade företags-AI-funktioner."
        }
    }
}